var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsForElementsRotateRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 8.3L14.3 5.6C14 5.3 13.4 5.3 13.1 5.6C12.8 5.9 12.8 6.5 13.1 6.8L14.7 8.3C12.3 8.5 10.1 9.5 8.4 11.2C6.7 12.9 5.7 15.2 5.5 17.6C5.5 18.1 5.8 18.5 6.3 18.5C6.3 18.5 6.3 18.5 6.4 18.5C6.8 18.5 7.2 18.2 7.2 17.7C7.4 15.6 8.2 13.8 9.6 12.4C11 11 12.9 10.2 14.9 10L13.2 11.8C12.9 12.1 12.9 12.7 13.2 13C13.4 13.2 13.6 13.2 13.8 13.2C14 13.2 14.2 13.1 14.4 12.9L17.1 10.1C17.3 9.8 17.5 9.5 17.5 9.2C17.5 8.9 17.4 8.6 17.1 8.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsForElementsRotateRight);
export default ForwardRef;